<template>
  <div class="d-download">
    <div v-if="isLoading" class="d-loading-tip">加载中...</div>
    <div v-else class="d-content">
      <FirstScreen v-if="currentVersion" :currentVersion="currentVersion" :latest-tips="!isLatestVersion" />
      <VersionDescription :desc="currentVersion.description" />
      <TableVersionHistory :version-list="histroyList" :latest-tag="!isLatestVersion" />
    </div>
  </div>
</template>

<script>
import FirstScreen from './components/FirstScreen.vue';
import TableVersionHistory from './components/TableVersionHistory.vue';
import VersionDescription from './components/VersionDescription.vue';
import {
  getHistoryVersions,
} from './api/index';

// 测试url: http://localhost:8080/ios-prod.html?packageName=com.gwssi.g.framework&agentId=acMDsKASFrrUbfDj
export default {
  name: 'Download',
  components: {
    FirstScreen,
    TableVersionHistory,
    VersionDescription,
  },
  computed: {
    appType() {
      return (location.pathname.indexOf('android') > -1) ? 'Android' : 'iOS';
    },
    packageName() {
      return location.pathname.replace(/.+-/, '').replace('.html', '');
    },
  },
  data() {
    return {
      isLoading: true,
      isAndroid: window.browser.android,
      isIPhone: window.browser.iPhone,
      currentVersion: {},
      histroyList: [],
      isLatestVersion: true
    };
  },
  created() {
    this.getVersionList();
  },
  methods: {
    getVersionList() {
      getHistoryVersions({
        pageSize: 10,
        pageNum: 1,
        platform: this.appType === 'iOS' ? 'IOS' : 'ANDROID',
        packageName: this.$route.query.packageName,
        agentId: this.$route.query.agentId,
        version: this.$route.query.version || 'latest'
      }).then(({ data }) => {
        this.currentVersion = data.current || null;
        this.isLatestVersion = data.current.version === data.history[0].version;
        this.histroyList = data.history.filter(item => item.version !== data.current.version);
        this.isLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.d-download {
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  .d-content {
    min-height: 100%;
  }
  .d-loading-tip {
    font-size: 32px;
    text-align: center;
    color: #c0c4cc;
    transform: translateY(-50%);
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
  }
}
@media screen and (min-width: 769px) {
  .d-download {
    .d-content {
      height: 100%;
      width: 700px;
      margin: 0 auto;
    }
  }
}
</style>
